export default "__VITE_ASSET__Cct0qOIQ__"